import { render, staticRenderFns } from "./AddPersonal.vue?vue&type=template&id=2703d4e0&scoped=true"
import script from "./AddPersonal.vue?vue&type=script&lang=js"
export * from "./AddPersonal.vue?vue&type=script&lang=js"
import style0 from "./AddPersonal.vue?vue&type=style&index=0&id=2703d4e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2703d4e0",
  null
  
)

export default component.exports